module.exports = __webpack_public_path__ + "img/d1bd1f6.jpg";